import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from '@apollo/client';

const getIsItemSaved = (items, id) => {
    const ids = items.map(i => i.recordId);
    return ids.includes(id);
};

const getIsFavorite = (savedItems, type, id) => {
    if (type === 'event') {
        return getIsItemSaved(savedItems.viewerEvents, id);
    }
    if (type === 'article') {
        return getIsItemSaved(savedItems.articles, id);
    }
    if (type === 'contact' || type === 'member') {
        return getIsItemSaved(savedItems.contacts, id);
    }
    if (type === 'publication') {
        return getIsItemSaved(savedItems.publications, id);
    }
    if (type === 'company') {
        return getIsItemSaved(savedItems.companies, id);
    }
    if (type === 'session') {
        return getIsItemSaved(savedItems.sessions, id);
    }
};
/**
 * Copied from https://github.com/darylthornhill/react-sprinkle and modified
 * A simpler version of sprinkle that doesn't include redux like our existing sprinkle
 * reactSprinkle
 * Allows user to add a custom html tag eg. test-tag into the page and
 * and Render the wrapped component into it.
 * Automatically parses json when passed into a prop to be available as an object in the react component.
 * @param {*} WrappedComponent
 * @param {*} customHtmlTag
 * @param {Object} globalProps
 * @returns {*} WrappedComponent
 */
export default function reactSprinkle({ WrappedComponent, customHtmlTag, globalProps = {}, savedItems }) {
    /**
     * Get the elements in the page
     */
    const elements = document.getElementsByTagName(customHtmlTag);

    /**
     * Loop through elements that are in the page, get props and render the WrappedComponent
     */
    Array.from(elements).forEach(element => {
        element.innerHtml = '';

        const props = globalProps;

        for (let i = 0, atts = element.attributes, n = atts.length; i < n; i++) {
            const propName = atts[i].nodeName;
            let { value } = atts[i];

            try {
                value = JSON.parse(value);
            } catch (e) {}

            props[propName] = value;
        }

        if (savedItems) {
            // saved items are sometimes null. This is probably just on staging.
            const nonNullSavedItems = {};
            for (const [type] of Object.entries(savedItems)) {
                nonNullSavedItems[type] = savedItems[type].filter(i => i !== null);
            }

            props.isFavorite = getIsFavorite(nonNullSavedItems, props.type, props.id);
        }

        const component = React.createElement(WrappedComponent, props, null);
        if (props.client) {
            ReactDOM.render(<ApolloProvider client={props.client}>{component}</ApolloProvider>, element);
        } else {
            ReactDOM.render({ component }, element);
        }
    });

    /**
     * Return Wrapped Components
     */
    return WrappedComponent;
}
